import type { BadgeColor, Status } from "./types";

export const ALL_STATUSES: Status[] = [
  "In Progress",
  "Waiting",
  "Pending",
  "Ongoing",
  "Not Started",
  "Complete",
];

export const STATUS_STYLE: Record<Status, { badge: string; dot: string }> = {
  "In Progress": {
    badge: "bg-blue-50 text-blue-700 ring-1 ring-blue-200",
    dot: "bg-blue-500",
  },
  Waiting: {
    badge: "bg-amber-50 text-amber-700 ring-1 ring-amber-200",
    dot: "bg-amber-500",
  },
  Pending: {
    badge: "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
    dot: "bg-slate-400",
  },
  Ongoing: {
    badge: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
    dot: "bg-emerald-500",
  },
  "Not Started": {
    badge: "bg-gray-100 text-gray-500 ring-1 ring-gray-200",
    dot: "bg-gray-300",
  },
  Complete: {
    badge: "bg-teal-50 text-teal-700 ring-1 ring-teal-200",
    dot: "bg-teal-500",
  },
};

// Pipeline-only dropdown options. Sourced from the Excel funnel tracker;
// empty value renders the placeholder so users can also type free-form anywhere.
export const INDUSTRY_CATEGORIES: string[] = [
  "AI",
  "BioTech",
  "Consumer/Sports/Wellness",
  "Devices",
  "Digital Health",
  "MedTech",
  "Robotics",
  "SaaS",
  "Services",
];

export const FINANCIAL_STAGES: string[] = [
  "Pre-Seed",
  "Seed",
  "Pre-Series A",
  "Series A",
  "Series B",
  "Series C",
  "Crossover",
  "Growth",
  "Public",
];

// Per Funnel sheet: MRF Eligible | MRF Emerging | MRF Nucleate | Parking Lot
export const THESIS_ALIGNMENT_OPTIONS: string[] = [
  "MRF Eligible",
  "MRF Emerging",
  "MRF Nucleate",
  "Parking Lot",
];

export const YN_OPTIONS: string[] = ["Y", "N"];
export const RANKING_OPTIONS: string[] = ["Low", "Medium", "High"];

// Palette for badge-column options. Class strings are written out in full so
// Tailwind's scanner picks them up — do not build these names dynamically.
export const BADGE_COLOR_STYLE: Record<
  BadgeColor,
  { label: string; badge: string; dot: string; swatch: string }
> = {
  gray: {
    label: "Gray",
    badge: "bg-gray-100 text-gray-600 ring-1 ring-gray-200",
    dot: "bg-gray-400",
    swatch: "bg-gray-400",
  },
  blue: {
    label: "Blue",
    badge: "bg-blue-50 text-blue-700 ring-1 ring-blue-200",
    dot: "bg-blue-500",
    swatch: "bg-blue-500",
  },
  green: {
    label: "Green",
    badge: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
    dot: "bg-emerald-500",
    swatch: "bg-emerald-500",
  },
  amber: {
    label: "Amber",
    badge: "bg-amber-50 text-amber-700 ring-1 ring-amber-200",
    dot: "bg-amber-500",
    swatch: "bg-amber-500",
  },
  red: {
    label: "Red",
    badge: "bg-red-50 text-red-700 ring-1 ring-red-200",
    dot: "bg-red-500",
    swatch: "bg-red-500",
  },
  purple: {
    label: "Purple",
    badge: "bg-violet-50 text-violet-700 ring-1 ring-violet-200",
    dot: "bg-violet-500",
    swatch: "bg-violet-500",
  },
  teal: {
    label: "Teal",
    badge: "bg-teal-50 text-teal-700 ring-1 ring-teal-200",
    dot: "bg-teal-500",
    swatch: "bg-teal-500",
  },
  pink: {
    label: "Pink",
    badge: "bg-pink-50 text-pink-700 ring-1 ring-pink-200",
    dot: "bg-pink-500",
    swatch: "bg-pink-500",
  },
};

export const BADGE_COLOR_ORDER: BadgeColor[] = [
  "gray",
  "blue",
  "green",
  "amber",
  "red",
  "purple",
  "teal",
  "pink",
];

// Options with no assigned color, and values typed before an option list
// changed, fall back to this.
export const NEUTRAL_BADGE_STYLE = {
  badge: "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
  dot: "bg-slate-400",
};
